export default __webpack_public_path__ + "static/media/laptop_green.b171ba34.svg";